import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { deactivateUser, deleteUser } from 'modules/settings/api';

export const useMutationDeleteUser = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { successToast, errorToast } = useCustomToast();

  const { mutateAsync, isLoading, isError } = useMutation(deleteUser, {
    onSuccess: () => {
      successToast(t('User successfully removed'));
      queryClient.invalidateQueries(QUERY_KEYS.SETTINGS_PROFILE_USERS);
    },
    onError: () => errorToast(),
    onSettled: () => queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_DELETE_USERS),
  });

  const { mutateAsync: deactivateUserMutate, isLoading: deactivateUserIsLoading } = useMutation(
    deactivateUser,
    {
      onSuccess: () => {
        successToast(t('User successfully deactivated'));
        queryClient.invalidateQueries(QUERY_KEYS.SETTINGS_PROFILE_DETAILS);
      },
      onError: (errResponse: any) => {
        const errorMessage = errResponse?.response?.data?.ErrorDescription;
        errorToast(t(errorMessage));
      },
      onSettled: () => queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_DELETE_USERS),
    },
  );

  return {
    deleteUserMutate: mutateAsync,
    deleteUserLoading: isLoading,
    deleteUserError: isError,
    deactivateUserMutate,
    deactivateUserIsLoading,
  };
};
